import React from 'react';
import i18next from 'i18next';
import { Wrapper, Description, Bar, BarActive } from './wrapper';

interface Props {
  valueCurrent: number;
  valueMax: number;
}

const ProgressBar = ({ valueCurrent, valueMax }: Props) => {
  const barWidth = (valueCurrent / valueMax) * 100;

  return (
    <Wrapper>
      <Description>
        {i18next.t('other.showingNumberOfResults', { current: valueCurrent, count: valueMax })}
      </Description>
      <Bar>
        <BarActive
          style={{ width: `${barWidth}%` }}
          aria-label={i18next.t('other.showingNumberOfResults', { current: valueCurrent, count: valueMax })}
          aria-valuenow={valueCurrent}
          aria-valuemin={0}
          aria-valuemax={valueMax}
        />
      </Bar>
    </Wrapper>
  );
};

export default ProgressBar;
